import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["paymentElement", "error", "form", "loader"]
  static values = {
    publicKey: String,
    clientSecret: String,
    returnUrl: String
  }

  connect() {
    this.initializePaymentElement()
  }

  initializePaymentElement() {
    this.stripe = Stripe(this.publicKeyValue)
    this.elements = this.stripe.elements({ clientSecret: this.clientSecretValue })

    this.paymentElement = this.elements.create("payment")
    this.paymentElement.mount(this.paymentElementTarget)

    this.paymentElement.on('ready', () => {
      this.loaderTarget.classList.add('opacity-0')
      setTimeout(() => {
        this.loaderTarget.classList.add('hidden')
        this.formTarget.classList.remove('hidden', 'opacity-0', 'scale-95')
      }, 300)
    })
  }

  async submit(event) {
    event.preventDefault()
    this.errorTarget.textContent = ''

    const { error } = await this.stripe.confirmPayment({
      elements: this.elements,
      confirmParams: { return_url: this.returnUrlValue }
    })

    if (error) this.showError(error)
  }

  showError(error) {
    this.errorTarget.textContent = error.message
  }
}
